export default __webpack_public_path__ + "static/media/time-icon.f9847aba.svg";